up.preview("link-spinner", function (preview) {
  let spinner = up.element.createFromHTML('<span class="loader"></span>');
  let elt = preview?.renderOptions?.submitButton;
  if (elt) {
    elt.append(spinner);
    elt.querySelector(".js-may-load").remove();
  }
  return () => {
    spinner.remove();
  };
});
